import React from "react";
import OrganizedTourFlightTimeline from "../OrganizedTourProfile/components/OrganizedTourFlightTimeline";
import { extractOrganizedTourFlightLegs } from "../../../utils/organizedTourProfileFlights";

/**
 * בלוק «פרטי טיסה» להצעה הציבורית — רק אם יש רגלי טיסה ב-linkedFlights.
 */
export default function OrganizedTourPublicOfferFlightsBlock({ linkedFlights, titleAfterBlock = false }) {
  const legs = extractOrganizedTourFlightLegs(linkedFlights);
  if (!legs.length) return null;
  return (
    <section className="organized-tour-public-offer__flights-section">
      <h3
        className={`organized-tour-public-offer__panel-section-title organized-tour-public-offer__flights-section-title${
          titleAfterBlock ? " organized-tour-public-offer__panel-section-title--after-block" : ""
        }`.trim()}
      >
        פרטי טיסה
      </h3>
      <OrganizedTourFlightTimeline linkedFlights={linkedFlights} />
    </section>
  );
}
